<h2 mat-dialog-title translate>Backup Manager</h2>
<mat-divider></mat-divider>
<div id="page">
  <div [ngClass]="{ 'current-page': activeTab === BACKUP_DIALOG_TABS.ROOM_SELECTOR }"></div>
  <div [ngClass]="{ 'current-page': activeTab === BACKUP_DIALOG_TABS.DEVICE_SCANNER }"></div>
  <div [ngClass]="{ 'current-page': activeTab === BACKUP_DIALOG_TABS.BACKUP_PROGRESS }"></div>
</div>
<mat-tab-group mat-tab-group-headerless dynamicHeight [selectedIndex]="activeTab">
  <!-- ROOM_SELECTOR -->
  <mat-tab>
    <div class="tab-content">
      <mat-dialog-content>
        <h3 mat-dialog-title translate>Choose Backup destination</h3>
        <div id="destination-info">
          <div>
            <span translate>Drive:</span>

            <ng-container *ngIf="selectedRoom && isAllActiveDriveInfoLoading">
              <ng-container *ngIf="selectedRoom?.data">
                <app-avatar [blob]="selectedRoom.data.avatar"></app-avatar>
                <span class="room-name">{{ selectedRoom?.data?.name }}</span>
              </ng-container>
              <span *ngIf="!selectedRoom?.data" class="room-name">{{ data.roomId }}</span>
            </ng-container>

            <mat-form-field *ngIf="!isAllActiveDriveInfoLoading">
              <mat-label>Select Drive</mat-label>
              <mat-select (selectionChange)="onRoomSelect($event.value)" [value]="selectedRoom">
                <mat-option *ngFor="let room of driveList" [value]="room">
                  <div class="option-cont">
                    <ng-container *ngIf="room?.data">
                      <app-avatar [blob]="room.data.avatar"></app-avatar>
                      <span class="room-name">{{ room?.data?.name }}</span>
                    </ng-container>
                    <span *ngIf="!room?.data" class="room-name">{{ room.id }}</span>
                  </div>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <ng-container *ngIf="selectedRoom">
            <div *ngIf="selectedRoom">
              <span translate>Path:</span>
              <div id="path-to-upload">
                <span *ngIf="data.pathToUpload" class="path">"/{{ data.pathToUpload }}/"</span>
                <span *ngIf="data.pathToUpload === ''" translate class="path">Drive Root</span>
              </div>
            </div>
            <div id="browse-panel">
              <button mat-raised-button color="primary" (click)="browsePathToUpload()" translate>Browse</button>
            </div>
          </ng-container>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-button (click)="close()" translate>Cancel</button>
        <button mat-raised-button color="primary" [disabled]="!selectedRoom" (click)="goToScanTab()" translate>Next</button>
      </mat-dialog-actions>
    </div>
  </mat-tab>
  <!-- DEVICE_SCANNER -->
  <mat-tab>
    <div class="tab-content">
      <mat-dialog-content>
        <h3 mat-dialog-title translate>File scanning</h3>
        <div id="scan-button-cont">
          <button mat-raised-button [disabled]="scanFiles" color="primary" (click)="scanDeviceFiles()" translate>Start Device Scan</button>
        </div>
        <div class="note" translate>Backup requires "Photos and Videos" permission on mobile device.</div>
        <div class="scan-progress" *ngIf="scanPhase > SCAN_PHASES.NOT_STARTED">
          <ul>
            <li [ngClass]="{ 'inactive-scan-phase': scanPhase < p.phase }" *ngFor="let p of scanPhaseTitles">
              <mat-spinner diameter="24" *ngIf="scanPhase === p.phase && scanFiles"></mat-spinner>
              <mat-icon *ngIf="scanPhase < p.phase">help</mat-icon>
              <mat-icon color="primary" *ngIf="scanPhase > p.phase">check_circle</mat-icon>
              <mat-icon color="warn" *ngIf="scanPhase === p.phase && !scanFiles">cancel</mat-icon>
              <span>{{ p.title }}</span>
            </li>
          </ul>
          <div id="scan-errors" *ngIf="scanErrors.length">
            <div *ngFor="let e of scanErrors" class="warn">
              <mat-icon>warning</mat-icon><span>{{ e }}</span>
            </div>
          </div>
          <div id="scan-result" *ngIf="!scanErrors.length && scanMetaInfo">
            <table>
              <tr>
                <td><span translate>Device Files:</span></td>
                <td>
                  <span>{{ scanMetaInfo.allFiles.amount }}</span>
                  <span translate> files</span>
                </td>
                <td>
                  <span>{{ scanMetaInfo.allFiles.size | formatBytes }}</span>
                </td>
              </tr>
              <tr>
                <td><span translate>Already Uploaded:</span></td>
                <td>
                  <span>{{ scanMetaInfo.allFiles.amount - scanMetaInfo.upload.amount }}</span>
                  <span translate> files</span>
                </td>
                <td>
                  <span>{{ scanMetaInfo.allFiles.size - scanMetaInfo.upload.size | formatBytes }}</span>
                </td>
              </tr>
              <tr>
                <td><span translate>Files to upload:</span></td>
                <td>
                  <span>{{ scanMetaInfo.upload.amount }}</span>
                  <span translate> files</span>
                </td>
                <td>
                  <span>{{ scanMetaInfo.upload.size | formatBytes }}</span>
                </td>
              </tr>
              <tr>
                <td><span translate>Backup state:</span></td>
                <td>
                  <span>{{ ((scanMetaInfo.allFiles.size - scanMetaInfo.upload.size) / scanMetaInfo.allFiles.size) * 100 | number : '1.0-0' }}%</span>
                </td>
              </tr>
            </table>
            <div class="primary backup-done" *ngIf="scanPhase === SCAN_PHASES.DONE && !filesToUpload?.length" translate>The backup is complete. All files are synced on the drive.</div>
          </div>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-button (click)="close()" translate>Cancel</button>
        <button mat-button (click)="resetStates(); activeTab = BACKUP_DIALOG_TABS.ROOM_SELECTOR" translate>Back</button>
        <button mat-raised-button color="primary" [disabled]="scanPhase !== SCAN_PHASES.DONE || !filesToUpload.length" (click)="startBackup()" translate>Start Backup</button>
      </mat-dialog-actions>
    </div>
  </mat-tab>
  <!-- BACKUP_PROGRESS -->
  <mat-tab>
    <div class="tab-content">
      <mat-dialog-content>
        <h3 mat-dialog-title translate>Backup In Progress</h3>
        <div id="keep-open-msg">
          <span translate>Keep phone open until finished!</span>
        </div>
        <div class="scan-progress">
          <ul>
            <li>
              <mat-spinner diameter="24" *ngIf="!backup"></mat-spinner>
              <mat-icon color="primary" *ngIf="backup">check_circle</mat-icon>
              <span translate>Backup initializing</span>
            </li>
            <li [ngClass]="{ 'inactive-scan-phase': !backup }">
              <mat-spinner diameter="24" *ngIf="backup && backup?.state !== STATE.DONE && backup?.state !== STATE.ERROR"></mat-spinner>
              <mat-icon *ngIf="!backup">help</mat-icon>
              <mat-icon color="primary" *ngIf="backup?.state === STATE.DONE">check_circle</mat-icon>
              <mat-icon color="warn" *ngIf="backup?.state === STATE.ERROR">cancel</mat-icon>
              <span>Backup in progress</span>
            </li>
            <li [ngClass]="{ 'inactive-scan-phase': scanPhase === SCAN_PHASES.NOT_STARTED }">
              <mat-spinner diameter="24" *ngIf="scanFiles"></mat-spinner>
              <mat-icon *ngIf="scanPhase === SCAN_PHASES.NOT_STARTED">help</mat-icon>
              <mat-icon color="primary" *ngIf="scanPhase === SCAN_PHASES.DONE">check_circle</mat-icon>
              <mat-icon color="warn" *ngIf="scanPhase > SCAN_PHASES.NOT_STARTED && scanPhase < SCAN_PHASES.DONE && !scanFiles">cancel</mat-icon>
              <span>Check backup result</span>
            </li>
          </ul>
          <div id="scan-errors" *ngIf="scanErrors.length">
            <div *ngFor="let e of scanErrors" class="warn">
              <mat-icon>warning</mat-icon><span>{{ e }}</span>
            </div>
          </div>
        </div>
        <div id="backup-cont" *ngIf="backup">
          <div id="details" *ngIf="backup.state === STATE.RUNNING || backup.state === STATE.RETRY || backup.state === STATE.PAUSED">
            <div id="current-info">
              <div id="current-file">{{ backup.currentFile?.name }}</div>
              <div id="progress-info" *ngIf="backup.uploadFiles">{{ backup.uploadFiles.length - backup.queueFiles.length }}/{{ backup.uploadFiles.length }}</div>
            </div>
            <div id="current-file-progress-bar">
              <mat-progress-bar mode="determinate" [value]="currFileProgress"></mat-progress-bar>
            </div>
            <div id="overall-file-progress-bar">
              <mat-progress-bar mode="determinate" [value]="((backup.uploadFiles.length - backup.queueFiles.length) / backup.uploadFiles.length) * 100"></mat-progress-bar>
            </div>
          </div>
          <div id="actions" *ngIf="backup">
            <button mat-raised-button *ngIf="backup.state === STATE.RUNNING || backup.state === STATE.RETRY" [matTooltip]="'Pause the operation' | translate" (click)="pause()">
              <mat-icon>pause</mat-icon>
              <span translate>Pause</span>
            </button>
            <button
              mat-raised-button
              *ngIf="backup.state === STATE.PAUSED || backup.state === STATE.ERROR"
              [matTooltip]="'Cancel backup' | translate"
              (click)="resetStates(); activeTab = BACKUP_DIALOG_TABS.DEVICE_SCANNER"
            >
              <mat-icon>delete</mat-icon>
              <span translate>Cancel Backup</span>
            </button>
            <button mat-raised-button *ngIf="backup.state === STATE.PAUSED" [matTooltip]="'Resume the operation' | translate" (click)="resume()">
              <mat-icon>play_arrow</mat-icon>
              <span translate>Resume</span>
            </button>
          </div>
          <div id="warnings" class="warn" *ngIf="backup.errors.length">
            <div *ngFor="let err of backup.errors">
              <mat-icon color="warn">warning</mat-icon>
              <span>
                {{ err.msg }}
              </span>
            </div>
          </div>
          <div id="scan-result" *ngIf="!scanErrors.length && scanMetaInfo">
            <table>
              <tr>
                <td><span translate>Files To Upload:</span></td>
                <td>
                  <span>{{ scanMetaInfo.allFiles.amount }}</span>
                  <span translate> files</span>
                </td>
                <td>
                  <span>{{ scanMetaInfo.allFiles.size | formatBytes }}</span>
                </td>
              </tr>
              <tr>
                <td><span translate>Successfully Uploaded:</span></td>
                <td>
                  <span>{{ scanMetaInfo.allFiles.amount - scanMetaInfo.upload.amount }}</span>
                  <span translate> files</span>
                </td>
                <td>
                  <span>{{ scanMetaInfo.allFiles.size - scanMetaInfo.upload.size | formatBytes }}</span>
                </td>
              </tr>
              <tr>
                <td><span translate>Missing Files:</span></td>
                <td>
                  <span>{{ scanMetaInfo.upload.amount }}</span>
                  <span translate> files</span>
                </td>
                <td>
                  <span>{{ scanMetaInfo.upload.size | formatBytes }}</span>
                </td>
              </tr>
              <tr>
                <td><span translate>Backup state:</span></td>
                <td>
                  <span>{{ ((scanMetaInfo.allFiles.size - scanMetaInfo.upload.size) / scanMetaInfo.allFiles.size) * 100 | number : '1.0-0' }}%</span>
                </td>
              </tr>
            </table>
            <div class="primary backup-done" *ngIf="scanPhase === SCAN_PHASES.DONE && !filesToUpload?.length" translate>The backup is complete. All files are synced on the drive.</div>
            <div class="warn backup-done" *ngIf="scanPhase === SCAN_PHASES.DONE && filesToUpload?.length > 0" translate>The backup is not complete. Some files are not synced.</div>
          </div>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-button (click)="close()" translate>Close</button>
        <button
          mat-button
          *ngIf="(backup?.state === STATE.DONE && (scanMetaInfo || scanErrors.length)) || backup?.state === STATE.ERROR"
          (click)="resetStates(); activeTab = BACKUP_DIALOG_TABS.DEVICE_SCANNER"
          translate
        >
          Back
        </button>
      </mat-dialog-actions>
    </div>
  </mat-tab>
</mat-tab-group>
